import { FC } from 'react';
import { IGreenhouseOptimizedData } from '@pro/linearTopLight/interface';
import { ProdOverlayBanner } from '@app/linearTopLight/ProdOverlayBanner';
import { ModuleHeader } from '@app/linearTopLight/ModuleHeader';
import { GridRender } from '@base/snippets/GridRender';
import { HtmlRender } from '@base/snippets/HtmlRender';
import DownloadModal, { DownloadRenderProps } from '@app/common/DownloadModal';
import { Button } from '@base/lib/Button';
import Image from '@base/lib/ThemeImage';
import { useRouter } from 'next/router';
import { RouteEnum } from 'pro/config/routers';
import { generatePath } from 'ava-util/dist/request';
import cn from 'classnames';
import styles from './index.module.less';

type IGreenhouseOptimizedProps = {
    data: IGreenhouseOptimizedData;
};

export const GreenhouseOptimized: FC<IGreenhouseOptimizedProps> = ({ data }) => {
    const { download, guarantee, contact } = data;
    const { pathname } = useRouter();

    return (
        <div className={styles['greenhouse']}>
            <ProdOverlayBanner data={data}>
                <div>
                    <ModuleHeader
                        className={styles.header}
                        title={data.title}
                    />

                    <div className={styles.list}>
                        <GridRender
                            colsPerRow={2}
                            gutter={64}
                            list={data.list}
                            render={item => (
                                <>
                                    <HtmlRender className={cn(styles['item-title'], 'g-font-ext-medium')} html={item.title}/>
                                    <HtmlRender className={styles['item-desc']} html={item.description}/>
                                </>
                            )}
                        />
                    </div>
                </div>

                <div className={'flex flex-middle flex-justify'}>
                    <DownloadModal
                        fileUrl={download.fileUrl}
                        fileName={download.fileName}
                        title="PLEASE FILL OUT THE FOLLOWING FORM TO DOWNLOAD Full Specifications."
                        moduleId={`${pathname} SPECIFICATIONS`}
                    >
                        {({ onDownload }: DownloadRenderProps) => (
                            <div>
                                <Button
                                    className={cn(styles['btn-download'], 'flex flex-middle')}
                                    onClick={onDownload}
                                    type={'no-style'}
                                    icon={
                                        <Image
                                            className={styles['btn-download-icon']}
                                            src={'file-asset/file/addd4584e5d310f09b137c1802497ed4.svg'}
                                            width={35}
                                            background={false}
                                            fixed
                                        />
                                    }
                                >
                                    {download.btnText}
                                </Button>
                            </div>
                        )}
                    </DownloadModal>

                    <Image
                        src={guarantee.src}
                        width={guarantee.width}
                        height={guarantee.height}
                        background={false}
                        fixed
                        pure
                    />
                </div>
            </ProdOverlayBanner>
            <div className="g-wrapper">
                <div className={cn(styles.contact, 'flex flex-middle flex-justify')}>
                    <HtmlRender className={styles['contact-title']} html={contact.title}/>
                    <Button
                        className={styles['contact-btn']}
                        type={'base'}
                        shape={'round'}
                        href={generatePath(RouteEnum.CONTACT, { from: `${pathname} Greenhouse CONTACT US` })}
                    >
                        {contact.btnText}
                    </Button>
                </div>
            </div>
        </div>
    )
};
